import React from 'react';
import { SVGProps } from './types';

function CircleFilled(props: SVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      fill="none"
      viewBox="0 0 8 8"
    >
      <circle cx="4" cy="4" r="4" fill="#D92D20" />
    </svg>
  );
}

export { CircleFilled };
